import { AxiosResponse } from 'axios';
import { useAlert, useAuth } from '../core/contexts';
import { instance as axiosInstance } from '../core/util/axiosInstance';
import { getDownloadFileCustomHeaders } from '../core/util/other';
import { commonShowAlert } from '../lib';
import { useQuery, UseQueryResult } from 'react-query';

const fetchExportDbSchema = async (
    url: string,
    token: string
): Promise<AxiosResponse<any, any>> => {
    return axiosInstance().get(url, getDownloadFileCustomHeaders(token));
};

export const useExportDbSchema = (): UseQueryResult<
    AxiosResponse<any, any>,
    unknown
> => {
    const { getToken } = useAuth();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    const url = '/dbschema';
    return useQuery(
        'export-dbschema',
        async () => fetchExportDbSchema(url, getToken()),
        {
            enabled: false,
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            onError: (error: any) => {
                const errorMessage: string =
                    error?.data?.message ?? 'Unable to export dbschema';

                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
